export enum LayoutConfigurationReferenceType {
  BorrowerProfile = 'borrowerProfile',
  ApplicationForm = 'applicationForm',
  PortalPage = 'portalPage',
}
